namespace $.$$ {
	
	$mol_style_define( $mol_canvas, {
			
		alignSelf: 'stretch',
		justifySelf: 'stretch',
		
		flex: {
			grow: 1,
			shrink: 1,
		},
		
	} )
	
}
